import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Empty } from '../error/empty';
import { SaveHttpError } from '../error/save-http-error';

@Injectable()
export class FileService {
  private static FILE_UPLOAD = '/file';

  private BULK_FILE_UPLOAD_ATTENDING = `${FileService.FILE_UPLOAD}/attendingInfo`;
  private BULK_FILE_UPLOAD_APPRAISAL = `${FileService.FILE_UPLOAD}/appraisal`;
  private BULK_FILE_UPLOAD_VALIDATION = `${FileService.FILE_UPLOAD}/validation`;

  save$: Observable<any>;
  error$: Observable<any>;

  private saveSubject: Subject<any>;
  private errorSubject: Subject<any>;

  constructor(private _httpService: HttpService) {
    this.saveSubject = new Subject();
    this.save$ = this.saveSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  saveAttendingFiles(files, attendingInfo?) {
    try {
      return this.saveFiles(
        files,
        this.BULK_FILE_UPLOAD_ATTENDING,
        'attending',
        'attendingInfoId',
        attendingInfo.id
      );
    } catch (e) {
      return this.saveFiles(files, this.BULK_FILE_UPLOAD_ATTENDING, 'attending');
    }
  }

  saveAppraisalFiles(files, appraisal?) {
    try {
      return this.saveFiles(
        files,
        this.BULK_FILE_UPLOAD_APPRAISAL,
        'appraisal',
        'appraisalId',
        appraisal.id
      );
    } catch (e) {
      return this.saveFiles(files, this.BULK_FILE_UPLOAD_ATTENDING, 'appraisal');
    }
  }

  saveValidationFiles(files, validation?) {
    try {
      return this.saveFiles(
        files,
        this.BULK_FILE_UPLOAD_VALIDATION,
        'validation',
        'validationId',
        validation.id
      );
    } catch (e) {
      return this.saveFiles(files, this.BULK_FILE_UPLOAD_VALIDATION, 'validation');
    }
  }

  private saveFiles(files, url, targetFolder, entityIdLabel?, entityId?) {
    const entityParam = entityId ? `${entityIdLabel}=${entityId}&` : '';
    this.updateFilesUrl(files);
    const formData = this.createFormData(files);
    if (files && files.length > 0) {
      this._httpService.post(`${url}?${entityParam}targetFolder=/${targetFolder}`,
        formData, Array, SaveHttpError)
        .subscribe(
          savedFiles => {
            this.saveSubject.next(savedFiles);
          },
          error => {
            error.text = 'Erro ao salvar as imagens!';
            this.errorSubject.next(error);
          }
        );
    } else {
      this.saveSubject.next();
    }
  }

  private createFormData(files) {
    const formData = new FormData();
    if (files.length > 0) {
      for (let index = 0; index < files.length; index++) {
        formData.append('files[]', files[index]);
      }
    }
    return formData;
  }

  private updateFilesUrl(files) {
    for (const file of files) {
      try {
        file.url = file.url.changingThisBreaksApplicationSecurity;
      } catch (e) { }
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/file.service.ts